import { Collapse, Grid, Typography } from '@mui/material'
import { format, parseISO } from 'date-fns'
import React from 'react'
import { useStyles } from './style'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'
import QueueIcon from '@mui/icons-material/Queue'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'

const TemplateItem = React.memo(({ template, index, onClick, onNewTemplate, onKeyPress, level = 1 }) => {
  const hasChildren = React.useMemo(() => !!template?.children?.length, [template.children])
  const [collapsed, setCollapsed] = React.useState(false)
  const { isActive } = template

  const classes = useStyles({ isActive })

  const CollapseIcon = () => collapsed
    ? <RemoveIcon className={classes.collapseIcon} />
    : <AddIcon className={classes.collapseIcon} />

  const handleClick = React.useCallback((e) => {
    if (!hasChildren) return
    e.stopPropagation()
    setCollapsed(collapsed => !collapsed)
  }, [setCollapsed, hasChildren])

  const onAddTemplate = React.useCallback((e) => {
    e.stopPropagation()
    onNewTemplate && onNewTemplate(template)
  }, [onNewTemplate, template])

  return (
    <>
      <Grid
        role='row button'
        data-test={`tenant-list-item-${index}`}
        container
        tabIndex={0}
        direction='row'
        alignItems='center'
        classes={{ root: classes.root }}
        onClick={() => onClick(template)}
        onKeyPress={(e) => onKeyPress(e, template)}
      >
        <Grid item md={1} className={classes.column} data-test='collapse-button' onClick={handleClick}>
          {hasChildren && <CollapseIcon />}
        </Grid>
        <Grid item md={3} className={classes.column}>
          <Grid container alignItems='center' spacing={2}>
            {level > 1 && (
              <Grid item className={classes.accountIcon}>
                <AccountTreeOutlinedIcon />
              </Grid>
            )}
            <Grid item>
              <Typography variant='body2' data-test={`tenant-name-${index}`}>
                {template.name}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={3} data-test='children-count-column'>
          {template?.children?.length || 'None'}
        </Grid>
        <Grid item md={2} data-test='creation-date'>
          <Typography className={classes.lastUpdate} variant='body2' data-test={`creation-date-${index}`} title={format(parseISO(template.createdAt), 'PPpppp')}>
            {parseISO(template.updatedAt).toLocaleDateString()}
          </Typography>
        </Grid>
        <Grid item md={2} container alignItems='center' data-test='status' />
        <Grid item md={1} container alignItems='center' data-test='add-template-base' onClick={onAddTemplate}>
          <QueueIcon />
        </Grid>

      </Grid>
      <Collapse in={collapsed} className={classes.collapse}>
        {template?.children?.map((child, key) => (
          <TemplateItem
            key={key}
            index={key}
            template={child}
            lastOne={key === template.children.length - 1}
            onClick={onClick}
            onKeyPress={onKeyPress}
            level={level + 1}
          />
        ))}
      </Collapse>
    </>
  )
})

export default TemplateItem
